import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineClients = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M16.429 17.857h2.857v-.714c0-3.06-2.138-5.62-5-6.27M12.143 2.233q.343-.09.714-.09a2.857 2.857 0 1 1-.714 5.624M7.143 10.714a6.43 6.43 0 0 0-6.429 6.429v.714h12.858v-.714a6.43 6.43 0 0 0-6.43-6.429M7.143 7.857a2.857 2.857 0 1 0 0-5.714 2.857 2.857 0 0 0 0 5.714"
    />
  </svg>
);
export default SvgStreamlineClients;
